import React, { useState } from "react"; 
import Footer from "../footer/Footer";
import Breadcrumb from "../breadcrumb/breadcrumb";
import { FaHome } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import Sidebar from "./sidebar/sidebar"; 
import styles from "./layouts.module.css";
import MenuLegged from "../header/Menu";

const DoctorManagement = () => {
  const { section, subsection, action } = useParams();  
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "สำหรับแพทย์", url: "" },
    ...(section === "guideline"
      ? [{ name: "แนวทางการตรวจ", url: "/doctor/guideline" }]
      : section === "document"
      ? [{ name: "เอกสารที่เกี่ยวข้อง", url: "/doctor/document" }]
      : section === "access-rights"
      ? [{ name: "รายชื่อผู้ป่วยที่มีสิทธิเข้าถึงข้อมูล", url: "/doctor/access-rights" }]
       : section === "history-access-rights"
      ? [{ name: "ประวัติการขอเข้าถึงข้อมูล", url: "/doctor/history-access-rights" }]
       : section === "permission-lab-patient"
      ? [{ name: "ข้อมูลการตรวจยีน", url: "/doctor/permission-lab-patient" }]
      
      : [{ name: "ไม่พบเมนู", url: "/" }]),
  ];

  return (
    <>
      {/* <MenuLegged menuActive={"guideline"} />  */}
      <div className={styles.Breadcrumb}>
        <Breadcrumb pathItems={pathItems} />
      </div>

      <div className={`${styles.Sidebar} layout-page`}>
        <div style={{ display: "flex" }}>
          <Sidebar
            role={"doctor"}
            page={section}
            subsection={subsection}
            action={action}
          />
        </div>
      </div>

    </>
  );
};

export default DoctorManagement;
